import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import 'moment/locale/pt-br'

const Date = ({
  control,
  name,
  rules,
  id,
  placeholder,
  disabled,
  onValueChange,
  ...datePickerProps
}) => {
  const fieldId = id ?? name

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='pt-br'>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field, fieldState }) => (
          <DatePicker
            format='DD/MM/YYYY'
            id={fieldId}
            name={field.name}
            value={field.value ? moment(field.value) : null}
            onBlur={field.onBlur}
            onChange={(date) => {
              field.onChange(date)
              onValueChange?.(date)
            }}
            disableFuture
            slotProps={{
              textField: {
                label: placeholder,
                placeholder: 'DD/MM/AAAA',
                margin: 'normal',
                helperText: fieldState.error?.message,
                error: fieldState.invalid,
                slotProps: {
                  htmlInput: {
                    'data-testid': `test-${fieldId}`,
                    disabled
                  }
                }
              }
            }}
            {...datePickerProps}
          />
        )}
      />
    </LocalizationProvider>
  )
}

Date.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onValueChange: PropTypes.func
}

export default Date
